import { TrackingEvent } from 'webapp/enums/tracking';
import type { SearchProps } from 'webapp/utils/filter';

import type { Metric } from 'webapp/models-custom';
import FilterSortMetricLibraryMainBase from 'webapp/models-custom/filter-sort/metric-library-main-base';

export default class FilterSortMetricLibraryMainMetrics extends FilterSortMetricLibraryMainBase<Metric> {
	override searchProps: SearchProps = {
		name: 3,
		description: 2,
		'source.title': 1,
		'sourceType.name': 1,
	};

	override typedFilterEventName = TrackingEvent.METRIC_SEARCH;
	override trackingObjectName = 'metric';

	override sortByPopularityValue = 'usedCount';
	override sortByAlphabeticallyValue = 'name';

	override categoryFilterFunction(item: Metric, selected: string) {
		return !!item.sourceType?.categories.some((categoryName: string) => {
			return this.getCompactString(categoryName) === selected;
		});
	}

	override dataSourceFilterFunction(item: Metric, selected: string) {
		return !!item.dataSourceTypeKey.includes(selected);
	}

	override get isAnyFilterActive(): boolean {
		return this.filters.some((f) => (f.isSort ? false : f.isActive));
	}

	override resetFilters(): void {
		this.filters.forEach((f) => {
			if (f.isSort) {
				f.selectOption(f.options[0]!.id);
			} else {
				f.selectOption(f.defaultValue);
			}
		});
	}
}
